const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        metrics: {
          filterDate: "Filtrar por día",
          sales: {
            title: "Ventas",
            subtitle: "{{count}} purchase(s) enviado(s) al pixel",
          },
          clicks: {
            title: "Clics en el enlace",
            subtitle: "Accesos al contador en el día seleccionado",
          },
          conversations: {
            title: "Conversaciones iniciadas",
            subtitle: "Contactos identificados en Whaticket en el día",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          whatsappIdCopied:
            "¡ID de WhatsApp copiado! Péguelo en MacroDroid (campo whatsappId).",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          hybridConnected: {
            content:
              "Web activo: recibe mensajes y envía medios. Vincule USB para envío de texto por el teléfono.",
          },
          webOnlyConnected: {
            content:
              "Modo solo Web: recibe y envía todo por la sesión Web (ideal para iPhone).",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
          waitingAgent: {
            title: "Esperando agente Android",
            content: "Inicie android-bridge-agent en su PC y conecte el teléfono por USB.",
          },
          deviceConnected: {
            title: "Dispositivo Android conectado",
            content: "Sesión activa vía bridge USB.",
          },
          deviceOffline: {
            title: "Dispositivo sin conexión",
            content: "Agente local desconectado. Verifique USB, adb y el proceso del agente.",
          },
        },
        table: {
          name: "Nombre",
          whatsappId: "WhatsApp ID",
          whatsappIdHint:
            "Haga clic en el ID para copiar. Úselo en MacroDroid: \"whatsappId\": NÚMERO",
          copyWhatsappId: "Copiar WhatsApp ID",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          connectionMode: "Modo",
          phone: "Número",
          counterPhone: "Número contador",
          autoDisableCounter: "Desactivación automática",
        },
        autoDisable: {
          active: "Activa",
        },
        connectionMode: {
          hybrid: "Híbrido",
          web: "Solo Web",
        },
        meta: {
          panelTitle: "WhatsApp Oficial (Meta Cloud)",
          panelInstructions:
            "Conecte nuevos números con el registro incorporado de Meta (Embedded Signup). Sin QR Code Baileys.",
          connectButton: "Conectar WhatsApp (Meta)",
          reconnectButton: "Reconectar Meta",
          connecting: "Conectando con Meta…",
          cloudLabel: "Meta Cloud",
          coexistenceHint:
            "Coexistencia: después del registro, abra la app WhatsApp Business en el celular para finalizar la sincronización.",
          signupTitle: "Registro incorporado WhatsApp",
          signupInstructions:
            "Inicie sesión en Meta y seleccione o registre el número de WhatsApp Business. El token se guarda en esta conexión.",
        },
        bridge: {
          title: "Android Bridge (USB)",
          hybridTitle: "Modo híbrido (Web + USB)",
          agentOnline: "Agente local en línea",
          agentOffline: "Agente local desconectado",
          instructions:
            "Reciba mensajes por WhatsApp Web (QR). Envíe texto por USB cuando el agente esté en línea.",
          hybridInstructions:
            "1) Abra el QR Code y escanéelo en el teléfono. 2) En el mismo modal, seleccione el dispositivo USB y haga clic en Vincular dispositivo.",
          pairSectionTitle: "Vincular teléfono USB",
          pairHint:
            "Elija el dispositivo USB que escaneó este QR Code en esta instancia.",
          selectDevice: "Teléfono USB",
          noDevices: "Ningún teléfono detectado en el agente local.",
          agentRequired:
            "Inicie el agente Bridge en el PC con el teléfono conectado por USB.",
          alreadyPaired: "Dispositivo vinculado:",
          keepAwakeTitle: "Mantener pantalla encendida",
          keepAwakeMinutes: "Min",
          keepAwakeSave: "Guardar",
          keepAwakeSaved: "Temporizador de pantalla guardado.",
          keepAwakeInvalid: "Ingrese minutos válidos (0 desactiva).",
          keepAwakeActive: "Acción cada {{minutes}} min en el dispositivo USB.",
          keepAwakeOff: "Desactivado (0 = sin acción).",
          escrcpyHint: "Espejar pantalla: scrcpy -s DEVICE_SERIAL (o Escrcpy en el PC).",
          pairDevice: "Vincular dispositivo",
          paired: "¡Dispositivo vinculado con éxito!",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          counterPhone: "Número del contador",
          autoDisableCounter: "Desactivación automática",
          connectionMode: "Modo de conexión",
          connectionModeHybrid: "Híbrido (Web recibe + USB envía texto)",
          connectionModeWeb: "Solo Web (iPhone / sin USB)",
          connectionModeHybridHint:
            "Recibe mensajes por Web y envía texto por el teléfono Android vía USB.",
          connectionModeWebHint:
            "Recibe y envía todo por la sesión Web. Use para iPhone o cuando USB no funciona.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
        scanDone: "¡QR escaneado! Ahora vincule el teléfono USB.",
        webActive: "Sesión Web activa. Vincule el dispositivo USB abajo.",
        waiting: "Esperando código QR...",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
        paidBadge: "(PAGO)",
        scheduledBadge: "(AGENDADO)",
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      ticketsWhatsappSelect: {
        placeholder: "Números",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
        responseWindow: {
          open: "Ventana: {{time}}",
          openTip:
            "Ventana de 24h de Meta: cuenta desde el último mensaje del cliente. Respuestas libres mientras esté abierta.",
          closed: "Ventana: cerrada",
          closedTip:
            "Ventana de 24h cerrada. Use una plantilla aprobada o espere un nuevo mensaje del cliente.",
          noCustomerMessage: "Ventana: esperando cliente",
          noCustomerMessageTip:
            "Aún no hay mensaje del cliente. La ventana de 24h inicia cuando envíe uno.",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          waba: "WABA",
          meta: "META",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          pixel: "Pixel",
          campanhas: "Tracking",
          webhook: "Webhook",
          counterNumbers: "Números",
          leadMessages: "Registro de Mensajes",
          queues: "Linhas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          proxy: "Proxy",
        },
        appBar: {
          autoAttend: "Atención automática con IA",
          autoAttendSelectNumbers: "Elija los números con IA automática",
          autoAttendConfirm: "Activar",
          autoAttendCancel: "Cancelar",
          disableAllAi: "Apagar IA en todos los tickets",
          disableAllAiConfirm:
            "¿Apagar la IA en TODOS los tickets ahora? (atención, upsell y postventa)",
          disableAllAiDone: "IA apagada en {{count}} ticket(s).",
          translation: "Traducción en tiempo real (apagar para no gastar API)",
          translationNeedsKey:
            "Configure la clave Google Translation en Ajustes para activar",
          translationEnabled: "Traducción automática",
          agentLanguage: "Idioma principal (panel)",
          outputLanguage: "Idioma de salida (mensajes enviados)",
          translationPrivacyNote:
            "Principal: LibreTranslate en la VPS. Google queda en standby si Libre falla.",
          translationLibreUrl: "URL LibreTranslate",
          translationLibreHelp: "Ej.: http://127.0.0.1:5000 (localhost en la VPS)",
          translationSaveLibre: "Guardar URL Libre",
          translationLibreSaved: "URL LibreTranslate guardada",
          translationLibreConfigured: "LibreTranslate configurado (principal)",
          translationLibreMissing: "Sin URL Libre — use Google standby o configure",
          translationApiKey: "Google standby (API key)",
          translationApiKeyHelp:
            "Solo si LibreTranslate falla. Puede quedar vacío si Libre es estable.",
          translationSaveApiKey: "Guardar Google standby",
          translationKeySaved: "Clave Google guardada",
          translationKeyConfigured: "Google standby configurado",
          translationUsesGemini: "Usando clave Gemini de ajustes de IA",
          translationKeyMissing: "Sin Google standby",
          translationApiKeyEmpty: "Pegue la clave antes de guardar",
          translationApiKeyReplace: "Pegue una nueva clave para reemplazar",
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          aiAssistant: {
            title: "Asistente IA",
            privacyNote:
              "Las conversaciones se envían al proveedor de IA configurado (Gemini, Anthropic o Qwen). Configure las claves abajo.",
            provider: "Proveedor activo",
            geminiSection: "Google Gemini",
            anthropicSection: "Anthropic (Claude Sonnet)",
            qwenSection: "QwenCloud (Qwen 3.7 Plus)",
            model: "Modelo Gemini",
            anthropicModel: "Modelo Claude",
            qwenModel: "Modelo Qwen",
            apiKey: "Clave API Gemini",
            anthropicApiKey: "Clave API Anthropic",
            qwenApiKey: "Clave API Qwen / DashScope",
            saveApiKey: "Guardar clave Gemini",
            saveAnthropicApiKey: "Guardar clave Anthropic",
            saveQwenApiKey: "Guardar clave Qwen",
            postSalePromptTitle: "Upsell / post-pago (fallback global)",
            postSalePromptHelp:
              "Usado tras el 1.er pago si la conexión no tiene prompt de upsell vinculado. No confundir con posventa (soporte).",
            prompt: "Prompt upsell / post-pago",
            promptHelp:
              "Placeholders: {nome}, {telefone}, {valor_venda}, {utm_campaign}",
            savePrompt: "Guardar prompt upsell / post-pago",
            atendimentoPromptTitle: "Atención (fallback global)",
            atendimentoPromptHelp:
              "Solo si la conexión no tiene prompt de atención vinculado arriba.",
            atendimentoPrompt: "Prompt atención (fallback)",
            saveAtendimentoPrompt: "Guardar prompt atención",
            aftercarePromptTitle: "Posventa / soporte (fallback global)",
            aftercarePromptHelp:
              "Usado tras el 2.º pago si la conexión no tiene prompt de posventa. Calmar, apoyar, tratar quejas — no es upsell.",
            aftercarePrompt: "Prompt posventa (soporte)",
            saveAftercarePrompt: "Guardar prompt posventa (soporte)",
            autoAttendNewContactsOnly: "IA automática solo para contactos nuevos",
            autoAttendNewContactsOnlyHelp:
              "Cuando está activo, la atención automática con IA solo inicia para contactos que nunca recibieron respuesta humana. Quienes ya fueron atendidos por un agente esperan atención humana.",
            autoAttendNewContactsOnlyOptions: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
            maxReplies: "Máx. respuestas por hora (por ticket)",
            historyMessages: "Mensajes de historial en contexto (recomendado: 40+)",
            replyDelayMin: "Retraso mínimo (segundos)",
            replyDelayMax: "Retraso máximo (segundos)",
            replyDelayHelp:
              "La IA espera un tiempo aleatorio entre mínimo y máximo antes de responder. Si máximo = 0 o igual al mínimo, usa el mínimo fijo.",
          },
          aiPromptsSection: {
            title: "Prompts de IA",
            help:
              "1) Cree prompts en la biblioteca · 2) Asigne por conexión (atención, upsell, posventa) · 3) Fallbacks globales solo si la conexión no tiene prompt.",
          },
          aiPrompts: {
            title: "1. Biblioteca de prompts",
            help:
              "Cree y edite prompts guardados. Elija el modo (atención, upsell o posventa) y asígnelos en la sección siguiente.",
            name: "Nombre del prompt",
            mode: "Modo",
            modeHelp:
              "Flujo del prompt: atención, upsell (1.er pago) o posventa (2.º pago).",
            modes: {
              atendimento: "Atención",
              postsale: "Upsell / post-pago",
              aftercare: "Posventa (soporte)",
            },
            prompt: "Texto del prompt",
            active: "Activo",
            connections: "Conexiones vinculadas",
            actions: "Acciones",
            add: "Añadir prompt",
            save: "Guardar cambios",
            cancelEdit: "Cancelar edición",
            created: "Prompt creado",
            updated: "Prompt actualizado",
            deleted: "Prompt eliminado",
            confirmDelete:
              "¿Eliminar este prompt? Las conexiones vinculadas vuelven al fallback global.",
            required: "Complete nombre y texto del prompt",
            empty: "Aún no hay prompts guardados",
            yes: "Sí",
            no: "No",
          },
          aiPromptAssign: {
            title: "2. Asignación por conexión",
            help:
              "Para cada conexión WhatsApp, elija prompt de atención, upsell y posventa. Vacío = fallback global.",
            connection: "Conexión",
            useGlobal: "Fallback global",
            saved: "Prompt de la conexión actualizado",
            empty: "No se encontraron conexiones WhatsApp",
          },
          aiFallbacks: {
            title: "3. Fallbacks globales",
            help:
              "Solo se usan si la conexión no tiene prompt para ese modo. Instalaciones antiguas siguen funcionando solo con estos textos.",
          },
          ctaButtons: {
            sectionTitle: "Botones",
            sectionHelp:
              "1) Cree botones CTA en la biblioteca · 2) Asigne qué botones puede usar cada conexión WhatsApp. Sin vínculo = todos los botones (fallback).",
            libraryTitle: "1. Biblioteca de botones",
            libraryHelp:
              "Cree y edite botones con enlace (CTA). La IA usa [[CTA_BUTTON:Nombre]] y el agente los envía desde el chat.",
            assignTitle: "2. Asignación por conexión",
            assignHelp:
              "Para cada número/conexión, marque los botones permitidos. Lista vacía = usa todos los botones globales.",
            linkedButtons: "Botones",
            useAllButtons: "Todos los botones (fallback)",
            assignSaved: "Botones de la conexión actualizados",
          },
          translation: {
            title: "Traducción en tiempo real",
            privacyNote:
              "Usa Google Cloud Translation API. Active la API en Google Cloud Console (separada de Gemini).",
            enabled: "Traducción activa",
            agentLanguage: "Idioma del agente (lee y escribe en el panel)",
            apiKey: "Clave API Google Translation",
            apiKeyHelp:
              "Puede usar la misma cuenta Google que Gemini, pero debe activar Cloud Translation API.",
            saveApiKey: "Guardar clave de traducción",
            options: {
              enabled: "Activada",
              disabled: "Desactivada",
            },
          },
        },
      },
      messagesList: {
        aiBadge: "IA",
        translationLabel: "Traducción",
        sentTranslationLabel: "Enviado",
        translateButton: "Traducir",
        translating: "Traduciendo...",
        ctaUrl: {
          open: "Abrir enlace",
        },
        header: {
          assignedTo: "Asignado a:",
          aiActive: "IA activa",
          aiModeSdr: "Atención",
          aiModePostSale: "Upsell / Post-pago",
          aiModePostSaleShort: "Upsell",
          aiModeAftercare: "Posventa (soporte)",
          aiModeAftercareShort: "Posventa",
          aiDisable: "Desactivar IA",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            pixel: "Pixel",
            ai: "IA",
            aiOn: "IA activada",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        translationPreview: "Se enviará en {{language}}: {{text}}",
        translationAgentPreview: "Traducción al {{language}}: {{text}}",
        chatFlows: {
          label: "Flujos de chat",
          starting: "Iniciando…",
          started: "Flujo \"{{name}}\" iniciado.",
          confirmTitle: "Disparar flujo",
          confirmMessage:
            "¿Desea iniciar el flujo \"{{name}}\" en este ticket? Se reemplazará cualquier sesión activa anterior.",
          statusRunning: "En curso",
          statusWaiting: "Esperando respuesta",
          statusCompleted: "Flujo concluido",
          statusHandedOff: "Derivado al agente",
          statusError: "Error en el flujo",
          statusCancelled: "Flujo cancelado",
        },
        ctaUrl: {
          title: "Botón con enlace (CTA)",
          listTitle: "Botones con enlace guardados",
          createTitle: "Crear botón con enlace",
          editTitle: "Editar botón con enlace",
          name: "Nombre (opcional)",
          header: "Encabezado (opcional)",
          body: "Texto del mensaje",
          displayText: "Texto del botón",
          url: "URL (https)",
          footer: "Pie (opcional)",
          send: "Enviar",
          save: "Guardar",
          saveAndSend: "Guardar y enviar",
          cancel: "Cancelar",
          createNew: "Crear nuevo botón",
          edit: "Editar",
          delete: "Eliminar",
          emptyList: "Aún no hay botones guardados. Cree el primero.",
          clickToSend: "Clic para enviar",
          sending: "Enviando...",
          success: "Botón con enlace enviado",
          saved: "Botón guardado",
          updated: "Botón actualizado",
          deleted: "Botón eliminado",
          deleteConfirm: "¿Eliminar el botón \"{{name}}\"?",
          errors: {
            bodyRequired: "Informe el texto del mensaje",
            displayTextRequired: "Informe el texto del botón",
            invalidUrl: "Informe una URL válida que comience con https://",
          },
        },
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        customerLanguage: "Idioma del cliente",
        customerLanguageAuto: "Detectar automáticamente",
        pixelCreative: "Anuncio",
        pixelAdId: "AD ID",
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      metaOnboarding: {
        introTitle: "Checklist App Review (Meta WhatsApp)",
        introBody:
          "Valide lo que ya existe en Oficial y marque las pruebas manuales del App Review. Los badges verdes indican feature en el producto — no Advanced Access aprobado por Meta.",
        proofProgress: "Pruebas manuales marcadas: {{done}}/{{total}}",
        howToRecord: "Cómo grabar para App Review",
        markDone: "Marqué esta prueba / paso como concluido",
        privacyPolicyUrl: "URL de Política de Privacidad",
        termsUrl: "URL de Términos de Uso",
        policyHelper:
          "Pegue la URL pública y configúrela también en Meta App Dashboard → Settings → Basic.",
        termsHelper:
          "Opcional en el producto; Meta exige política pública. Los términos ayudan en la revisión.",
        savePolicyUrls: "Guardar URLs en Configuración",
        openPrivacy: "Abrir privacidad",
        openTerms: "Abrir términos",
        status: {
          available: "Disponible en el sistema",
          configure: "Configurar",
          external: "Acción externa (Meta)",
          manual: "Manual App Review",
        },
        sections: {
          messaging: "whatsapp_business_messaging",
          management: "whatsapp_business_management",
          prerequisites: "Prerrequisitos",
        },
        links: {
          tickets: "Conversaciones / Tickets",
          inbox: "Inbox",
          webhook: "Webhook (panel)",
          waba: "Panel WABA",
          wabaWebhooks: "WABA → Webhooks",
          wabaTemplates: "WABA → Templates",
          wabaSync: "WABA → Sincronizar",
          embeddedSignup: "Embedded Signup",
          connections: "Conexiones",
          settings: "Configuración",
          metaTemplates: "Templates en Business Manager",
          coexistenceDocs: "Docs Meta: Coexistencia",
          metaDevelopers: "Meta for Developers",
          metaPrivacy: "Requisitos de privacidad",
          metaAppDashboard: "App Dashboard Meta",
          appReviewDocs: "Docs App Review",
        },
        items: {
          msgSend: {
            title: "Enviar mensaje al cliente",
            desc:
              "Panel Conversas (/tickets) envía texto/media vía Meta Cloud API.",
            tip:
              "Grabe: abrir ticket → escribir → enviar → mensaje con check. Muestre número oficial Meta Cloud.",
          },
          msgReceive: {
            title: "Recibir mensajes en Inbox",
            desc:
              "Webhook Meta activo; mensajes entran en Tickets en tiempo real.",
            tip:
              "Grabe: cliente envía en WhatsApp → ticket actualiza en Inbox. Muestre también WABA → Webhooks o /webhook.",
          },
          msgAck: {
            title: "Estado de entrega/lectura (ACK)",
            desc:
              "Webhooks de status actualizan ticks en la lista de mensajes.",
            tip:
              "Envíe un mensaje y muestre la evolución de los íconos ACK.",
          },
          msgProof: {
            title: "Prueba de uso (messaging) para App Review",
            desc:
              "Video + descripción del flujo funcional de envío/recepción.",
            tip:
              "Un video continuo: Conexiones Meta → Tickets → enviar → recibir → ACK.",
          },
          mgmtConnect: {
            title: "Conectar WABA y número oficial",
            desc:
              "Embedded Signup en /waba-signup y gestión en Conexiones / WABA.",
            tip:
              "Grabe el Cadastro Incorporado hasta que el número aparezca en Conexiones.",
          },
          mgmtTemplates: {
            title: "Crear/editar templates",
            desc:
              "Listado/sync en WABA; creación avanzada en Business Manager (Meta).",
            tip:
              "Muestre templates en WABA y, si crea/edita, el flujo en BM. Creación completa es en Meta.",
          },
          mgmtSync: {
            title: "Sincronizar templates y cuenta WABA",
            desc: "Botón «Sincronizar admin» y pestañas en /waba.",
            tip:
              "Grabe: WABA → Sincronizar admin → números/templates/webhooks actualizados.",
          },
          mgmtWebhook: {
            title: "Suscripción de webhook y evento de prueba",
            desc:
              "Re-suscripción subscribed_apps en WABA + endpoint /webhook.",
            tip:
              "Muestre URL del webhook, re-suscripción y un evento real llegando.",
          },
          mgmtProof: {
            title: "Prueba de uso (management) para App Review",
            desc:
              "Video de gestión: conectar, sync, templates/webhooks.",
            tip:
              "Video separado de messaging: Embedded Signup → WABA sync → templates/webhooks.",
          },
          mgmtCoexistence: {
            title: "Coexistencia con WhatsApp Business app",
            desc:
              "Flag coexistence en Embedded Signup; activación final es recurso Meta + app en el celular.",
            tip:
              "Documente: featureType whatsapp_business_app_onboarding + abrir WhatsApp Business tras el signup. No finja Advanced Access.",
          },
          preDevAccount: {
            title: "Cuenta Meta Developer activa",
            desc: "App en developers.facebook.com con productos WhatsApp.",
            tip: "Muestre el App Dashboard (sin secrets) y productos WhatsApp.",
          },
          prePrivacy: {
            title: "Política de privacidad y términos públicos",
            desc:
              "URLs públicas en App Dashboard; opcionalmente guardadas aquí (privacyPolicyUrl / termsUrl).",
            tip:
              "Grabe la página pública de privacidad y el campo en Meta App Settings → Basic.",
          },
          preBusiness: {
            title: "Info del negocio / casos de uso alineados",
            desc:
              "Business Verification y descripción de uso consistentes con el producto.",
            tip:
              "En App Review, describa atención omnichannel WhatsApp oficial — alineado a Whaticket.",
          },
          preVideos: {
            title: "Video + descripción por permiso",
            desc:
              "Meta exige screencast y texto separados para messaging y management.",
            tip:
              "No reutilice el mismo video en ambos permisos. Marque las casillas tras grabar cada uno.",
          },
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_DISPLAY_NAME:
          "Meta bloqueó el envío: el nombre para mostrar del número aún no está aprobado en WhatsApp Manager.",
        ERR_WAPP_PAYMENT:
          "Meta bloqueó el envío: hay un error en el método de pago de la cuenta de WhatsApp Business.",
        ERR_WAPP_TOKEN:
          "Fallo de autenticación con Meta. Actualice el token de la conexión de WhatsApp.",
        ERR_WAPP_UNDELIVERABLE:
          "Meta no pudo entregar el mensaje a este número.",
        ERR_CTA_URL_META_ONLY:
          "Los botones con enlace (CTA) solo están disponibles con la API oficial de Meta.",
        ERR_CTA_URL_BODY_REQUIRED: "El texto del mensaje CTA es obligatorio.",
        ERR_CTA_URL_BODY_TOO_LONG:
          "El texto del mensaje CTA supera 1024 caracteres.",
        ERR_CTA_URL_DISPLAY_TEXT_REQUIRED:
          "El texto del botón CTA es obligatorio.",
        ERR_CTA_URL_DISPLAY_TEXT_TOO_LONG:
          "El texto del botón CTA supera 20 caracteres.",
        ERR_CTA_URL_INVALID_URL:
          "URL del CTA inválida. Use una dirección https://.",
        ERR_CTA_URL_HEADER_TOO_LONG:
          "El encabezado del CTA supera 60 caracteres.",
        ERR_CTA_URL_FOOTER_TOO_LONG:
          "El pie del CTA supera 60 caracteres.",
        ERR_TRANSLATION_FAILED:
          "No se pudo traducir el mensaje. Verifique la clave y Cloud Translation API en Google Cloud.",
        ERR_TRANSLATION_API_BLOCKED:
          "Cloud Translation API bloqueada. Actívela en console.cloud.google.com/apis/library/translate.googleapis.com y revise restricciones de la clave.",
        ERR_TRANSLATION_INVALID_KEY:
          "Clave Google Translation inválida. Genere una nueva en Google Cloud Console.",
        ERR_TRANSLATION_KEY_TEST_FAILED:
          "No se pudo validar la clave Google Translation. Intente de nuevo.",
        ERR_TRANSLATION_API_KEY_EMPTY: "Ingrese la clave Google Translation.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_PIXEL_INVALID_VALUE: "Ingrese un valor de venta válido.",
        ERR_PIXEL_LEAD_NOT_FOUND: "Lead del pixel no encontrado para este contacto.",
        ERR_PIXEL_ALREADY_CONVERTED: "Esta conversión ya fue enviada al pixel.",
        ERR_PIXEL_PHONE_NOT_FOUND: "Teléfono del contacto no encontrado.",
        ERR_PIXEL_SEND_FAILED: "Error al enviar conversión al pixel.",
        ERR_COUNTER_NUMBERS_LIST: "Error al listar números del contador.",
        ERR_COUNTER_NUMBER_ADD: "Error al agregar número.",
        ERR_COUNTER_NUMBER_TOGGLE: "Error al cambiar estado del número.",
        ERR_COUNTER_NUMBER_UPDATE: "Error al actualizar número.",
        ERR_COUNTER_NUMBER_DELETE: "Error al eliminar número.",
        ERR_LEAD_MESSAGES_LIST: "Error al listar mensajes recientes.",
        ERR_NO_CHAT_FLOW_FOUND: "Flujo de chat no encontrado.",
        ERR_CHAT_FLOW_NOT_FOUND: "Flujo de chat no encontrado.",
        ERR_CHAT_FLOW_INACTIVE: "Este flujo de chat está inactivo.",
        ERR_CHAT_FLOW_WHATSAPP_MISMATCH:
          "Este flujo no pertenece a la conexión WhatsApp de este ticket.",
        ERR_CHAT_FLOW_NO_START:
          "Este flujo no tiene un nodo inicial válido. Abra el editor y guarde el flujo otra vez.",
        ERR_CHAT_FLOW_START_FAILED:
          "No fue posible iniciar el flujo en este ticket. Inténtelo de nuevo.",
      },
      leadMessages: {
        title: "Registro de Mensajes",
        section: {
          title: "Últimos Mensajes Recibidos",
          subtitle:
            "Leads recientes — mensaje, número WPP destino, campaña y estado",
        },
        stats: {
          total: "Total de leads",
          today: "Leads hoy",
          converted: "Convertidos",
        },
        table: {
          date: "Fecha/Hora",
          message: "Mensaje",
          destination: "Nº WPP Destino",
          campaign: "Campaña",
          status: "Estado",
        },
        status: {
          pending: "Pendiente",
          converted: "Vendido · €{{value}}",
        },
        empty: "Aún no hay mensajes recibidos.",
      },
      proxy: {
        title: "Proxy WhatsApp",
        formatHint:
          "Pegue en formato host:puerto:usuario:contraseña — tipo por defecto HTTP (opcional: socks5 o socks4 al final)",
        status: {
          enabled: "Proxy activo",
          disabled: "Proxy desactivado",
        },
        source: {
          settings: "Origen: panel",
          env: "Origen: .env",
          none: "Sin proxy configurado",
        },
        fields: {
          enabled: "Usar proxy en WhatsApp",
          rawLine: "Proxy completo",
          parsedTitle: "Campos reconocidos automáticamente",
          host: "Host",
          port: "Puerto",
          username: "Usuario",
          password: "Contraseña",
          passwordKeep: "Deje en blanco para mantener la contraseña actual",
          type: "Tipo",
        },
        buttons: {
          save: "Guardar proxy",
          check: "Probar proxy",
          reload: "Recargar",
        },
        check: {
          ok: "Proxy funcionando",
          fail: "Fallo en la prueba del proxy",
          latency: "Latencia: {{ms}} ms",
          ip: "IP externa: {{ip}}",
        },
        toasts: {
          saved: "¡Proxy guardado con éxito!",
          checkOk: "¡Proxy probado con éxito!",
          checkFail: "El proxy no respondió",
        },
        note:
          "Después de cambiar el proxy, desconecte y reconecte la sesión de WhatsApp en Conexiones para aplicar el cambio.",
      },
      counterNumbers: {
        title: "Números del Contador",
        stats: {
          daily: "Clics del día",
          total: "Clics totales",
          active: "Canales activos",
        },
        form: {
          addTitle: "Agregar nuevo canal",
          name: "Nombre",
          namePlaceholder: "ej: WPP Principal",
          phone: "Teléfono",
          message: "Mensaje predeterminado (opcional)",
          add: "Agregar",
          save: "Guardar",
          cancel: "Cancelar",
          phoneRequired: "Informe el teléfono.",
        },
        table: {
          active: "Activo",
          name: "Canal",
          daily: "Clics (día)",
          total: "Clics (total)",
          rotation: "Rotación",
          actions: "Acciones",
        },
        rotation: {
          next: "Siguiente",
          last: "Último",
          queued: "En cola",
          inactive: "Inactivo",
        },
        edit: {
          title: "Editar canal",
        },
        confirmDelete: {
          title: "Eliminar número",
          message: "¿Está seguro? El número será eliminado del contador de clics.",
        },
        toasts: {
          added: "¡Número agregado con éxito!",
          updated: "¡Número actualizado!",
          deleted: "¡Número eliminado!",
        },
      },
      webhookPage: {
        title: "Webhook Stripe",
        endpoint1Title: "Endpoint 1 (Stripe principal)",
        endpoint2Title: "Endpoint 2 (segunda Stripe)",
        urlLabel: "URL del webhook (pegar en Stripe Dashboard)",
        copy: "Copiar",
        copied: "¡URL copiada!",
        copyFail: "No se pudo copiar.",
        refresh: "Actualizar",
        secretLabel: "Signing secret (whsec_...)",
        secretPlaceholder: "whsec_••••••••",
        secretSave: "Guardar secret",
        secretSaved: "¡Signing secret guardada!",
        secretRequired: "Ingrese el signing secret.",
        secretInvalid: "El secret debe empezar con whsec_.",
        secretHelp:
          "Pegue el Signing secret del Stripe Dashboard. Se guarda en la base (Settings) — sin reiniciar PM2.",
        secretConfiguredHint:
          "Configurada (••••{{last4}}). Escriba un valor nuevo para reemplazarla.",
        secretOk: "Signing secret configurada",
        secretOkMasked: "Configurada ••••{{last4}}",
        secretMissing: "Signing secret no configurada",
        instructions:
          "En Stripe → Developers → Webhooks → Add endpoint.\nEndpoint 1: pegue la URL del endpoint 1 en la cuenta Stripe principal.\nEndpoint 2: pegue la URL del endpoint 2 en la segunda cuenta Stripe.\nSeleccione checkout.session.* y payment_intent.*.\nLuego copie el Signing secret (whsec_...) de cada endpoint y guárdelo en el campo correspondiente (admin).\nNo hace falta secret key (sk_) — el panel solo valida la firma del webhook.\n\nEventos tratados:",
        logsTitle: "Últimas llamadas Stripe",
        empty: "Aún no hay eventos.",
        table: {
          createdAt: "Cuándo",
          eventType: "Evento",
          status: "Estado",
          contact: "Contacto",
          ticket: "Ticket",
          pixel: "Pixel",
          error: "Error",
        },
      },
      campanhasPage: {
        title: "Tracking",
        hint:
          "Registre el patrón del mensaje de WhatsApp + Meta IDs/UTMs. Al enviar un botón Stripe del sistema, las UTMs y client_reference_id se añaden automáticamente. Tras el pago (postback Stripe), el importe pagado se envía a Meta como Purchase.",
        empty: "Aún no hay tracking.",
        buttons: {
          add: "Nuevo tracking",
          save: "Guardar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          pattern: "Mensaje",
          mode: "Modo",
          metaIds: "Meta IDs",
          status: "Estado",
          actions: "Acciones",
        },
        modes: {
          contains: "Contiene",
          exact: "Exacta",
        },
        status: {
          on: "Activo",
          off: "Off",
        },
        modal: {
          create: "Nuevo tracking",
          edit: "Editar tracking",
        },
        form: {
          name: "Nombre",
          messagePattern: "Patrón del mensaje",
          messagePatternHelp:
            "Texto que el cliente envía en WhatsApp (emoji o frase de campaña).",
          matchMode: "Modo de match",
          enabled: "Activo",
          campaignId: "campaign_id",
          adsetId: "adset_id",
          adId: "ad_id",
          pixelId: "Pixel ID",
          pixelIdHelp:
            "ID del pixel Meta que recibirá las Purchases de este tracking. Solo este valor se usa al enviar.",
          currency: "Moneda (fallback)",
          currencyHelp:
            "Solo si el postback Stripe no trae moneda. El valor siempre viene del pago.",
          stripeLink: "Link Stripe Payment",
          stripeLinkHelp:
            "No usar — los botones Stripe del sistema reciben UTMs al enviar.",
          defaultValue: "Valor por defecto",
        },
        confirmation: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          saved: "Tracking guardado.",
          deleted: "Tracking eliminado.",
          required: "Nombre y patrón del mensaje son obligatorios.",
          pixelRequired: "Informe el Pixel ID del tracking.",
          copied: "Link Stripe copiado.",
          noStripe: "Añada el link Stripe en este tracking.",
        },
      },
      pixel: {
        title: "Pixel",
        creative: "Creativo",
        adLabel: "Anuncio",
        adId: "AD ID",
        trackingLabel: "Tracking",
        trackingMatched: "Tracking coincidente",
        trackingNotMatched: "Sin tracking por mensaje",
        adNotFound: "Anuncio no identificado",
        campaignLabel: "Campaña",
        campaignNotFound: "Campaña no identificada",
        search: "Buscar por mensaje, teléfono o creativo",
        loadMore: "Cargar más",
        stats: {
          total: "Verificados",
          complete: "Completos",
          incomplete: "Incompletos",
          converted: "Convertidos",
        },
        table: {
          contact: "Contacto",
          message: "Mensaje",
          creative: "Creativo",
          phone: "Teléfono",
          status: "Estado Pixel",
          checkedAt: "Verificado en",
        },
        status: {
          complete: "Completo",
          incomplete: "Incompleto",
          notFound: "No encontrado",
          convertedShort: "Convertido",
          converted: "Convertido · €{{value}}",
          purchasesSummary: "{{count}} purchase(s) · Total €{{value}}",
        },
        modal: {
          title: "Enviar conversión al Pixel",
          phone: "Teléfono (automático)",
          value: "Valor de la venta (€)",
          send: "Enviar al Pixel",
          sendUpsell: "Enviar upsell",
          cancel: "Cancelar",
          refresh: "Verificar de nuevo",
          message: "Mensaje rastreado",
          lookupDate: "Fecha del clic",
          leadDate: "Fecha del clic",
          lastPurchase: "Último envío",
          invalidValue: "Ingrese un valor válido.",
          success: "¡Conversión enviada al pixel con éxito!",
          upsellSuccess: "¡Upsell enviado al pixel con éxito!",
          refreshed: "Datos del pixel actualizados.",
        },
        manual: {
          title: "Búsqueda manual",
          date: "Fecha del clic",
          message: "Mensaje exacto",
          messagePlaceholder: "Pegue el mensaje que el cliente envió por WhatsApp",
          search: "Buscar lead",
          phone: "Teléfono del comprador",
          notFound: "No se encontró lead para este mensaje y fecha.",
          clear: "Limpiar",
          messageRequired: "Ingrese el mensaje para buscar.",
          dateRequired: "Ingrese la fecha del clic.",
          phoneRequired: "Ingrese el teléfono del comprador.",
        },
      },
    },
  },
};

export { messages };
